import Vue from 'vue'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

if (window.bugsnagKey) {
  const bugsnagClient = Bugsnag.start({
    apiKey: window.bugsnagKey,
    releaseStage: window.appEnv,
    plugins: [new BugsnagPluginVue()],
    ...(window.appVersion ? { appVersion: window.appVersion } : {}),
  })

  const bugsnagVue = Bugsnag.getPlugin('vue')
  bugsnagVue.installVueErrorHandler(Vue)

  if (window.bugsnagUser) {
    bugsnagClient.user = window.bugsnagUser
  }
}
